// extracted by mini-css-extract-plugin
export default {"cls1":"gt53JyYavL_znVSugwfQ","cls2":"QyYm3aldvSmWgvAVFrke gt53JyYavL_znVSugwfQ"};